import { styled } from 'style'

const ProseStyled = styled('article', {
  color: '$text2',

  '> p + p': {
    mt: '$4',
  },

  '& p:not(:first-child) > img': {
    my: '$6',
  },

  '& [data-widget]': {
    my: '$4',
  },

  '& pre, & video': {
    my: '$5',
  },

  'h1, h2, h3, h4, h5, h6': {
    color: '$text1',
    fontWeight: '$bold',
  },

  '& h1': {
    mb: '$8',
    fontSize: '$4xl',
    lineHeight: '$4xl',
    letterSpacing: '$tighter',
  },

  '& h2': {
    my: '$6',
    fontSize: '$2xl',
    lineHeight: '$2xl',
  },

  '& h3': {
    my: '$4',
    fontSize: '$xl',
    lineHeight: '$xl',
    letterSpacing: '$normal',
  },

  '& h4': {
    my: '$3',
    fontSize: '$lg',
    lineHeight: '$lg',
    letterSpacing: '$normal',
  },

  '& h5': {
    fontSize: '$md',
    lineHeight: '$md',
    letterSpacing: '$normal',
  },

  '& h6': {
    fontSize: '$sm',
    lineHeight: '$sm',
    letterSpacing: '$normal',
  },

  '& a': {
    color: '$success',
    '&:hover': {
      color: '$successHover',
    },
  },

  'b, strong': {
    fontWeight: '$bold',
  },

  '& em': {
    fontStyle: 'italic',
  },

  '& blockquote': {
    fontStyle: 'italic',
    borderLeftWidth: '0.25rem',
    borderLeftColor: '$bg3',
    quotes: `"“" "”" "‘" "’"`,
    pl: '$2',
    '> *:before': { content: 'open-quote' },
    '> *:after': { content: 'close-quote' },
  },

  '& hr': {
    borderTop: '1px solid $bg3',
    my: '$12 !important',
    mx: 'auto',
  },

  '& ul, & ol': {
    spaceY: 1,
    mt: '$5',
    mb: '$3',
    pl: '$5',

    '& ul, & ol': {
      mt: '$2',
      mb: '$1',
    },
  },

  '& li:not(:first-child)': {
    my: '$1',
  },

  '& ul': {
    listStyleType: 'disc',
    ul: {
      listStyleType: 'circle',
      ul: {
        listStyleType: 'square',
      },
    },
  },

  '& ol': {
    listStyleType: 'decimal',
  },

  '& div+ul': {
    marginTop: 0,
  },
})

export default ProseStyled
